import { takeEvery } from '../../listenerMiddleware';
import * as previewActions from './actions';
import { api } from '../../../general/apiScenarios';
import { message } from '@myua/kit';
import { getInProgress, getModal } from './selectors';
import * as finderActions from '../finder/actions';
import { Mode, Page } from '../finder/model';
import { Action } from 'redux';
import * as viewerActions from '../viewer/actions';
import * as packActions from '../pack/actions';
import * as favoriteActions from '../favorite/actions';
import * as sharingActions from '../sharing/actions';

export const previewListeners = () => {
  watchChangeRequested();
  watchDetailsChanged();
};

function watchChangeRequested() {
  takeEvery(
    [previewActions.removeRequested, previewActions.uploadRequested],
    async (action, { getState, dispatch }) => {
      const inProgress = getInProgress(getState());
      if (inProgress[action.payload.assetId]) {
        return;
      }

      let operation;
      let messageOk;
      let messageError;

      if (previewActions.uploadRequested.match(action)) {
        operation = api.preview.upload(action.payload.assetId, action.payload.file);
        messageOk = 'Custom preview uploaded';
        messageError = 'Failed to upload custom preview';
      } else {
        operation = api.preview.remove(action.payload.assetId);
        messageOk = 'Custom preview removed';
        messageError = 'Failed to remove custom preview';
      }

      dispatch(previewActions.setInProgress({ assetId: action.payload.assetId, inProgress: true }));
      const { success } = await operation;
      dispatch(
        previewActions.setInProgress({ assetId: action.payload.assetId, inProgress: false }),
      );

      if (success) {
        void message.success(messageOk);
        dispatch(finderActions.detailsRequested());

        const modal = getModal(getState());
        if (modal.assetId === action.payload.assetId) {
          dispatch(previewActions.setModal({ open: false }));
        }
      } else {
        void message.error(messageError);
      }
    },
  );
}

function watchDetailsChanged() {
  takeEvery(finderActions.detailsChanged, (action, { dispatch }) => {
    const { asset } = action.payload;
    if (!asset) {
      return;
    }
    const actions: Record<Mode, Action> = {
      [Page.viewer]: viewerActions.thumbnailUpdated({
        assetId: asset.id,
        url: asset.thumbnail_url,
      }),
      [Page.pack]: packActions.thumbnailUpdated({ assetId: asset.id, url: asset.thumbnail_url }),
      [Page.favorite]: favoriteActions.thumbnailUpdated({
        assetId: asset.id,
        url: asset.thumbnail_url,
      }),
      [Page.sharing]: sharingActions.thumbnailUpdated({
        assetId: asset.id,
        url: asset.thumbnail_url,
      }),
    };

    Object.values(actions).forEach((action) => dispatch(action));
  });
}
